import styled from 'styled-components';

import { navigation } from '@rewardopl/styles/z-index';

import { Wrapper as VendorLogo } from '../../common/vendor_logo.styles';

export const Wrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  grid-area: aside;
  padding-left: env(safe-area-inset-left);
  background: var(--menu-background);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  position: relative;
  z-index: ${navigation};

  ${VendorLogo} {
    display: none;
  }

  @media screen and (min-width: 769px) {
    width: 100%;
    padding: 15px;
    padding-left: max(15px, env(safe-area-inset-left));
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    overflow: auto;

    ${VendorLogo} {
      display: block;
      margin: 5px auto calc(var(--gap) + 5px);
    }
  }
`;
